module.exports = __webpack_public_path__ + "img/bonuses2.a6c2a70b.png";